export default function isOneIsh(value) {
	return value === '1' || value === 1;
}
